module.exports = __webpack_public_path__ + "img/icon-filter.6d869214.svg";